// extracted by css-extract-rspack-plugin
export default {"tableWrap":"CsvFileDescription__tableWrap--fN3i2","required":"CsvFileDescription__required--PAcJw"};